import React from "react";
import {
    Box, Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from "@mui/material";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { STATUS_META, FORM_TYPES } from "./approvalConstants";
import { ds } from "../../styles/designSystem";

dayjs.locale("ko");

/** 결재 구분(세부 유형) — 휴가신청서면 vacationType(연차/병가/대체휴무 등), 그 외는 — */
const subClass = (a) => {
    const d = a.form || {};
    if (a.type === "VACATION") return d.vacationType || "—";
    return "—";
};

/* 공용 결재 표 — 정상/관리자 모드 공통 (결재유형·제목·구분·기안자·결재자·상태·등록일) */
export default function ApprovalTable({ rows, selected, onSelect, emptyText = "결재 없음" }) {
    if (!rows || rows.length === 0) {
        return (
            <Box sx={{ textAlign: "center", py: 6, color: "#94a3b8" }}>
                <AssignmentRoundedIcon sx={{ fontSize: 36, mb: 1, opacity: 0.4 }} />
                <Typography sx={{ fontSize: 13 }}>{emptyText}</Typography>
            </Box>
        );
    }
    return (
        // 가로 스크롤 없이 컨테이너에 꽉 맞춘다(폭 100%, minWidth 해제). 모든 셀 가운데 정렬.
        <Table size="small" sx={{ ...ds.tableSx, minWidth: 0, width: "100%" }}>
            <TableHead>
                {/* 헤더 정렬·배경은 공통 프리셋(ds.tableSx → styles/presets/table.js: 헤더 전부 center) */}
                <TableRow>
                    <TableCell>기안자</TableCell>
                    <TableCell>상태</TableCell>
                    <TableCell>유형</TableCell>
                    <TableCell>제목</TableCell>
                    <TableCell>구분</TableCell>
                    <TableCell>결재자</TableCell>
                    <TableCell>등록일</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((a) => {
                    const ti = FORM_TYPES.find((f) => f.type === a.type);
                    const m  = STATUS_META[a.status] || STATUS_META.PENDING;
                    const approvers = a.lines?.map((l) => l.approverName).filter(Boolean).join(" → ") || "—";
                    return (
                        <TableRow key={a.id} hover selected={selected?.id === a.id}
                            sx={{ cursor: "pointer", "&:hover": { bgcolor: "#fafbfc" }, "&.Mui-selected": { bgcolor: "#eff6ff" },
                                "& .MuiTableCell-root": { borderBottom: "1px solid #f1f5f9" } }}
                            onClick={() => onSelect(a)}>
                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                                {a.submitterName || "—"}
                                {a.submitterDept
                                    ? <Box component="span" sx={{ color: "#94a3b8", fontSize: 11, ml: 0.5 }}>· {a.submitterDept}</Box>
                                    : null}
                            </TableCell>
                            <TableCell align="center">
                                <Chip label={m.label} size="small" sx={{ bgcolor: m.bg, color: m.color, fontWeight: 700 }} />
                            </TableCell>
                            <TableCell align="center" sx={{ whiteSpace: "nowrap", color: "#475569", fontWeight: 600 }}>
                                {a.typeLabel || ti?.label || a.type}
                            </TableCell>
                            <TableCell align="center" sx={{ fontWeight: 600, color: "#1e293b" }}>{a.title}</TableCell>
                            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>{subClass(a)}</TableCell>
                            <TableCell align="center" sx={{ color: "#64748b", fontSize: 12 }}>{approvers}</TableCell>
                            <TableCell align="center" sx={{ color: "#64748b", fontSize: 12, whiteSpace: "nowrap" }}>
                                {dayjs(a.createdAt).format("YYYY.MM.DD HH:mm")}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
}
